module.exports = __webpack_public_path__ + "static/media/overdue-img.6ac53f44.svg";